import { render } from "./TableWithFixedHeader.vue?vue&type=template&id=e3de7944"
import script from "./TableWithFixedHeader.vue?vue&type=script&lang=js"
export * from "./TableWithFixedHeader.vue?vue&type=script&lang=js"
script.render = render

export default script